import React, { useMemo } from "react"
import { Product } from "../CategoryDetails"
import {
  Badge,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap"
import TableContainer from "components/Common/TableContainer"
import { useTranslation } from "react-i18next"

interface CategoryProductsTableProps {
  products: Product[]
  toggleAllProducts: () => void
  togglecheckedProductHandler: (product: Product) => void
  isAllChecked: boolean
  checkedProducts: Product[]
  toggleActiveProduct: (product: Product) => void
}

const CategoryProductsTable: React.FC<CategoryProductsTableProps> = ({
  products,
  toggleAllProducts,
  togglecheckedProductHandler,
  isAllChecked,
  checkedProducts,
  toggleActiveProduct,
}) => {
  const { t } = useTranslation()

  const columns = useMemo(
    () => [
      {
        Header: () => (
          <input
            type="checkbox"
            className="form-check-input"
            onChange={e => {
              e.stopPropagation()
              toggleAllProducts()
            }}
            checked={isAllChecked}
          />
        ),
        accessor: "id",
        Cell: (cellProps: { row: { original: Product } }) => {
          return (
            <input
              onChange={() =>
                togglecheckedProductHandler(cellProps.row.original)
              }
              checked={Boolean(
                checkedProducts.find(o => o.id === cellProps.row.original.id)
              )}
              type="checkbox"
              className="form-check-input"
            />
          )
        },
      },
      {
        Header: t("products_products"),
        accessor: "name",
        filterable: true,
        Cell: (cellProps: { row: { original: Product } }) => {
          const {image , name} = cellProps.row.original
          return (
            <div className="d-flex align-items-center gap-2">
              <img
                className="rounded-circle"
                src={image}
                alt=""
                style={{ width: "36px", height: "36px" }}
              />
              <span className="">{name}</span>
            </div>
          )
        },
      },
      {
        Header: t("products_couponBased"),
        accessor: "couponBased",
        filterable: true,
        Cell: (cellProps: { row: { original: Product } }) => {
          return (
            <>
              {cellProps.row.original.couponBased ? (
                <div className="badge bg-primary-30 text-primary fw-semibold">
                  {t("products_couponBased")}
                </div>
              ) : (
                <Badge className="bg-cyan-30 text-cyan fw-semibold">
                  {t("products_oneTime")}
                </Badge>
              )}
            </>
          )
        },
      },
      {
        Header: t("common_price"),
        accessor: "price",
        filterable: true,
        Cell: (cellProps: { row: { original: Product } }) => {
          return (
            <>
              {t("common_qar")}
              {cellProps.row.original.price}
            </>
          )
        },
      },
      {
        Header: t("common_size"),
        accessor: "size",
        filterable: true,
        Cell: (cellProps: { row: { original: Product } }) => {
          return <>{cellProps.row.original.size}</>
        },
      },
      {
        Header: t("products_stock"),
        accessor: "stock",
        filterable: true,
        Cell: (cellProps: { row: { original: Product } }) => {
          return <>{cellProps.row.original.stock}</>
        },
      },
      {
        Header: t("products_featured"),
        accessor: "featured",
        filterable: true,
        Cell: (cellProps: { row: { original: Product } }) => {
          return (
            <div className="d-flex flex-wrap">
              {cellProps.row.original.featured ? (
                <div className="badge bg-success-30 text-success fw-semibold">
                  {t("products_featured")}
                </div>
              ) : (
                <></>
              )}
            </div>
          )
        },
      },
      {
        Header: t("common_status"),
        accessor: "status",
        filterable: true,
        Cell: (cellProps: { row: { original: Product } }) => {
          return (
            <div className="form-check form-switch mb-3">
              <input
                type="checkbox"
                className="form-check-input"
                id={`customSwitch${cellProps.row.original.id}`}
                checked={cellProps.row.original.status === "Active"}
                onChange={e => {
                  e.stopPropagation()
                  toggleActiveProduct(cellProps.row.original)
                }}
              />
              <label
                className="form-check-label text-capitalize"
                htmlFor={`customSwitch${cellProps.row.original.id}`}
              >
                {cellProps.row.original.status}
              </label>
            </div>
          )
        },
      },
      {
        Header: " ",
        Cell: (cellProps: { row: { original: Product } }) => {
          const product = cellProps.row.original
          return (
            <UncontrolledDropdown>
              <DropdownToggle tag="a" className="card-drop">
                <i className="mdi mdi-dots-vertical font-size-18"></i>
              </DropdownToggle>

              <DropdownMenu className="dropdown-menu-end">
                <DropdownItem onClick={() => console.log(product.id)}>
                  <span className="">{t("common_edit")}</span>
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          )
        },
      },
    ],
    [products, t, checkedProducts]
  )
  return (
    <TableContainer
      columns={columns}
      data={products}
      isGlobalFilter={true}
      isAddOptions={false}
      customPageSize={5}
      isJobListGlobalFilter={undefined}
      isAddUserList={undefined}
      handleOrderClicks={undefined}
      handleUserClick={undefined}
      handleCustomerClick={undefined}
      isAddCustList={undefined}
      className={undefined}
      customPageSizeOptions={undefined}
    />
  )
}

export default CategoryProductsTable
